import { colors } from 'app-v2/design-systems/theme'
import { COLOR } from 'app-v2/design-tokens'
import { Close, Light } from 'app/assets/icons'
import { H3, Text } from 'app/common/typography'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { orderPickUpType } from 'shared/utils'
import styled from 'styled-components'

const { TABLESERVICE, DRIVE, PARKING, TABLE_ORDER } = orderPickUpType

type Props = {
    collectMode: string,
    geolocationRequired?: boolean,
    handleClose: () => void
}

export const ModalTutorialCollectMode = ({
    collectMode,
    geolocationRequired,
    handleClose
}: Props) => {
    let textKey
    switch (collectMode) {
        case DRIVE:
            textKey = 'clickandcollect.collect.tutorial.drive'
            break
        case TABLESERVICE:
            textKey = 'clickandcollect.collect.tutorial.servicetable'
            break
        case PARKING:
            textKey = geolocationRequired
                ? 'clickandcollect.collect.tutorial.parking.geoloc'
                : 'clickandcollect.collect.tutorial.parking'
            break
        case TABLE_ORDER:
            textKey = 'ecommerce.collect.tutorial.tableorder'
            break
        default:
            textKey = 'clickandcollect.collect.tutorial.takeaway'
    }
    return (
        <ContainerModal>
            <ContainerTop>
                <CloseButtonContainer onClick={handleClose}>
                    <Close color="white" size={24} />
                </CloseButtonContainer>
                <FormattedMessage id="clickandcollect.collect.tutorial.title">
                    {(text: string) => (
                        <H3 center color="white">
                            {text}
                        </H3>
                    )}
                </FormattedMessage>
            </ContainerTop>
            <Diagonal />
            <ContainerBottom>
                <Light color={COLOR.PRIMARY} />
                <FormattedMessage id={textKey}>
                    {(text: string) => (
                        <StyledText center>{text.toString()}</StyledText>
                    )}
                </FormattedMessage>
            </ContainerBottom>
        </ContainerModal>
    )
}

const ContainerModal = styled.div``

const ContainerTop = styled.div`
    background-color: ${colors.crunchyGreen};
    padding: 80px 10px 40px;
    text-align: center;
`

const CloseButtonContainer = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
`

const Diagonal = styled.div`
    border-style: solid;
    border-right-width: 500px;
    border-left-width: 0px;
    border-color: ${colors.crunchyGreen} ${colors.crunchyGreen} white white;
    border-bottom-width: 20px;
    margin-top: -1px;
`

const ContainerBottom = styled.div`
    background-color: white;
    padding: 20px 40px 20px 40px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const StyledText = styled(Text)`
    margin: 20px 0;
`
